import { render, staticRenderFns } from "./BasePie.vue?vue&type=template&id=5c8900c8&scoped=true&"
import script from "./BasePie.vue?vue&type=script&lang=js&"
export * from "./BasePie.vue?vue&type=script&lang=js&"
import style0 from "./BasePie.vue?vue&type=style&index=0&id=5c8900c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8900c8",
  null
  
)

export default component.exports